/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Stores/PermissionsStore" />
import { Store } from "VSS/Reflux/Store";

import { Permissions } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Models";
import { StoreLoadingState } from "TFS/Views/ProjectOverviewPage/Shared/Contracts";

export interface PermissionsState {
    loadingState: StoreLoadingState;
    permissions: Permissions;
}

export class PermissionsStore extends Store {
    private _state: PermissionsState = {
        loadingState: StoreLoadingState.Loading,
        permissions: {
            hasViewActivityPanePermission: false
        }
    };

    public getState(): PermissionsState {
        return this._state;
    }

    public loadPermissions = (permissions: Permissions): void => {
        this._state.permissions = permissions;
        this._state.loadingState = StoreLoadingState.Loaded;

        this.emitChanged();
    };
}
